"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _theme = require("../theme");

var _core = require("@emotion/core");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function AriaClickHandler(props) {
  var ariaLabel = props.ariaLabel,
      innerRef = props.innerRef,
      children = props.children,
      expanded = props.expanded,
      hasPopup = props.hasPopup,
      onClick = props.onClick,
      restProps = (0, _objectWithoutProperties2.default)(props, ["ariaLabel", "innerRef", "children", "expanded", "hasPopup", "onClick"]);

  if (!onClick) {
    return (0, _core.jsx)(_react.default.Fragment, null, children);
  }

  return (0, _core.jsx)(StyledAriaClickHandler, (0, _extends2.default)({
    "aria-expanded": expanded,
    "aria-haspopup": hasPopup,
    "aria-label": ariaLabel,
    onClick: onClick,
    ref: innerRef
  }, restProps), children);
}

var StyledAriaClickHandler = (0, _theme.styled)('button')({
  background: 'transparent',
  border: 'none',
  borderRadius: 'inherit',
  color: 'inherit',
  display: 'inline-block',
  font: 'inherit',
  padding: 0,
  textAlign: 'initial',
  width: 'inherit'
}, function (_ref) {
  var theme = _ref.theme,
      disabled = _ref.disabled;

  if (disabled) {
    return _objectSpread({
      cursor: 'not-allowed'
    }, theme.components.ariaClickHandler.disabled);
  } else {
    return _objectSpread({
      cursor: 'pointer'
    }, theme.components.ariaClickHandler.enabled);
  }
});
var _default = AriaClickHandler;
exports.default = _default;